import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'BankAccountType';
const ENDPOINT = `/bank-account-types/`;

@Injectable({
    providedIn: 'root'
})
export class BankAccountTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
